<birdz-card
  [isLoading]="isLoading"
  [isEmpty]="!isLoading && queries.length === 0 && ((isFavoritesOnly && folders.length === 0) || isFolderMode)"
>
  <div card-title>{{ cardTitle | transloco }}</div>
  <div card-corner>
    @if (isFolderMode) {
      <button mat-stroked-button (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'TAB_FAVORITES' | transloco }}
      </button>
    }
    @if (isFavoritesOnly) {
      <button mat-stroked-button (click)="openCreateFolderModal()" [matTooltip]="'FOLDER_NEW_TOOLTIP' | transloco">
        <mat-icon>create_new_folder</mat-icon>
        {{ 'FOLDER_NEW' | transloco }}
      </button>
    }
    @if (!isFavoritesOnly && queries.length > 0) {
      <button mat-stroked-button [matMenuTriggerFor]="sortMenu">
        <mat-icon>sort</mat-icon>
        {{ currentSortLabelKey | transloco }}
      </button>
    }
    @if (isEditor && !isFolderMode) {
      <button mat-flat-button color="primary" routerLink="/query/new">
        <mat-icon>add</mat-icon>
        {{ 'CREATE_QUERY' | transloco }}
      </button>
    }
  </div>
  <div card-empty>
    {{ (isFolderMode ? 'FOLDER_EMPTY' : isFavoritesOnly ? 'NO_FAVORITES_YET' : 'NO_DATA_AVAILABLE') | transloco }}
  </div>
  <div card-body class="list-body">
    <mat-menu #sortMenu="matMenu">
      @for (option of sortOptions; track option.key) {
        <button mat-menu-item (click)="setSortBy(option.key)">
          @if (option.key === queryService.currentFilter$.value.sort_by) {
            <mat-icon>check</mat-icon>
          }
          {{ option.labelKey | transloco }}
        </button>
      }
    </mat-menu>

    <!-- Folder grid (favorites tab only) -->
    @if (isFavoritesOnly) {
      @if (folders.length > 0) {
        <div class="folders-section">
          <div class="section-label">{{ 'FOLDERS' | transloco }}</div>
          <div class="folder-grid">
            @for (folder of folders; track folder.id) {
              <div class="folder-card" (click)="navigateToFolder(folder)">
                <div class="folder-card__icon">
                  <mat-icon>folder</mat-icon>
                </div>
                <div class="folder-card__info">
                  <div class="folder-card__name">{{ folder.name }}</div>
                  <div class="folder-card__count">
                    {{ 'FOLDER_QUERY_COUNT' | transloco: { count: folder.queries_count } }}
                  </div>
                </div>
                <div class="folder-card__actions" (click)="$event.stopPropagation()">
                  <button mat-icon-button [matMenuTriggerFor]="folderMenu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #folderMenu="matMenu">
                    <button mat-menu-item (click)="openRenameFolderModal(folder, $event)">
                      <mat-icon>edit</mat-icon>
                      {{ 'FOLDER_RENAME' | transloco }}
                    </button>
                    <button mat-menu-item class="menu-item-warn" (click)="deleteFolder(folder, $event)">
                      <mat-icon>delete</mat-icon>
                      {{ 'FOLDER_DELETE' | transloco }}
                    </button>
                  </mat-menu>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (queries.length > 0 || folders.length === 0) {
        <div class="section-header">
          <div class="section-label">{{ 'TAB_FAVORITES' | transloco }}</div>
          @if (queries.length > 0) {
            <button mat-stroked-button [matMenuTriggerFor]="sortMenu">
              <mat-icon>sort</mat-icon>
              {{ currentSortLabelKey | transloco }}
            </button>
          }
        </div>
      }
    }

    @if (!isFavoritesOnly || queries.length > 0) {
      <mat-form-field appearance="fill" class="search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [(ngModel)]="searchText" [placeholder]="'QUERY_LIST_SEARCH' | transloco" autocomplete="off" />
        @if (searchText) {
          <button matSuffix mat-icon-button type="button" (click)="searchText = ''">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>

      @if (queries.length === 0 && isFavoritesOnly) {
        <!-- favorites tab with folders but no favorited queries: no list shown -->
      } @else {
        <div class="query-list">
          @for (query of filteredQueries; track query.id) {
            <a class="query-item" [ngClass]="getAccentClass(query)" [routerLink]="['/query', query.id]">
              <div class="query-icon-bubble">
                <mat-icon>{{ query.icon || 'table_chart' }}</mat-icon>
              </div>
              <div class="query-info">
                <div class="query-name">{{ query.name }}</div>
                @if (query.description) {
                  <div class="query-description">{{ query.description }}</div>
                }
                <div class="query-meta">
                  <span class="query-creator">{{ query.creator_email }}</span>
                  <span class="database-badge" [ngClass]="getDatabaseClass(query.database_id)">{{
                    query.database_id
                  }}</span>
                  @if (query.is_locked) {
                    <mat-icon class="lock-icon" [matTooltip]="'QUERY_LOCKED_TOOLTIP' | transloco">lock</mat-icon>
                  }
                </div>
              </div>

              <div class="query-right">
                @if ((query.tags && query.tags.length > 0) || query.deleted_at) {
                  <mat-chip-set class="query-tags">
                    @if (query.deleted_at) {
                      <mat-chip class="chip-deleted" disableRipple>{{ 'QUERY_DELETED_CHIP' | transloco }}</mat-chip>
                    }
                    @for (tag of query.tags; track tag) {
                      <mat-chip>{{ tag }}</mat-chip>
                    }
                  </mat-chip-set>
                }

                <div class="query-actions" (click)="$event.stopPropagation(); $event.preventDefault()">
                  @if (!query.is_public) {
                    <mat-icon class="private-icon" [matTooltip]="'QUERY_PRIVATE_TOOLTIP' | transloco"
                      >lock_person</mat-icon
                    >
                  }
                  <button
                    mat-icon-button
                    [class.favorite-active]="query.is_favorite"
                    [matTooltip]="'QUERY_FAVORITE' | transloco"
                    (click)="toggleFavorite(query, $event)"
                  >
                    <mat-icon>{{ query.is_favorite ? 'star' : 'star_border' }}</mat-icon>
                  </button>

                  <button mat-icon-button [matMenuTriggerFor]="actionsMenu" #actionsTrigger="matMenuTrigger">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionsMenu="matMenu">
                    <button mat-menu-item (click)="openAddToFolderModal(query, actionsTrigger)">
                      <mat-icon>folder_open</mat-icon>
                      {{ 'FOLDER_ADD_TO_FOLDER' | transloco }}
                    </button>
                    @if (isEditor) {
                      <button
                        mat-menu-item
                        [disabled]="isEditDisabled(query)"
                        [routerLink]="['/query', query.id, 'edit']"
                        [matTooltip]="isEditDisabled(query) ? ('QUERY_LOCKED_CREATOR_ONLY' | transloco) : ''"
                      >
                        <mat-icon>edit</mat-icon>
                        {{ 'QUERY_EDIT' | transloco }}
                      </button>
                      @if (!query.deleted_at) {
                        <button mat-menu-item (click)="openDuplicateModal(query, actionsTrigger)">
                          <mat-icon>content_copy</mat-icon>
                          {{ 'QUERY_DUPLICATE' | transloco }}
                        </button>
                        <button
                          mat-menu-item
                          class="menu-item-warn"
                          [disabled]="isEditDisabled(query)"
                          [matTooltip]="isEditDisabled(query) ? ('QUERY_LOCKED_CREATOR_ONLY' | transloco) : ''"
                          (click)="openDeleteModal(query, actionsTrigger)"
                        >
                          <mat-icon>delete</mat-icon>
                          {{ 'QUERY_DELETE' | transloco }}
                        </button>
                      }
                    }
                  </mat-menu>
                </div>
              </div>
            </a>
          }
        </div>
      }
    }
  </div>
</birdz-card>
